export default __webpack_public_path__ + "static/media/Reader's Arm-straps of the Crescent.749dcf7d.jpg";